
import { DiscoveryClient } from './axiosDiscoveryClient';
import { IMetadata } from '@ninjacart/nc-nk-core';
import paths from './path';
import { KisaanClient } from '@ninjacart/nc-nk-store';
interface IgetDiscoveryMetadataApi {
  statusCode: number;
  message: string;
  data: Array<IMetadata>;
}
export const getDiscoveryMetadataApi = async (
  payload
): Promise<IgetDiscoveryMetadataApi | null> => {
  try {
    const response = await KisaanClient.get<IgetDiscoveryMetadataApi>(
      paths.discoveryMetadata(payload)
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};
